

import React, { useState, useRef } from 'react';
import './dnd.css'


  import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    removeElements,
    Controls, Background
  } from 'react-flow-renderer';  


const style = {
    background: 'lightblue',
    width: '100%',
    height: 800
  };
  

  const nodeStyle = {
    background: 'beige',
    color: 'purple',
    border: '1px solid #222138',
    width: 180,
  };
  
  let id = 0;
  const getId = () => `dndnode_${id++}`;

  const ProcessRefinement = () => {


    const [entityName, setEntityName] = useState(['New'])
    const initialElements = [
      {
        id: '1',
        type: 'input',
        data: { label: 'ScreenFlow: ' + entityName },
        position: { x: 250, y: 50 },
        style: {
          background: 'yellowgreen',
          color: 'white',
          border: '1px solid #222138',
          width: 30,
        },
      }
    
    ];
    

  
    const [selectedElement, setSelectedElement] = useState(null)

    const [fromElement, setFromElement] = useState(1)
    const [toElement, setToElement] = useState(2)

    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const [elements, setElements] = useState(initialElements);

    const onConnect = (params) => setElements((els) => addEdge(params, els));
    const onElementsRemove = (elementsToRemove) =>
    setElements((els) => removeElements(elementsToRemove, els));
  
  

    const onLoad = (_reactFlowInstance) =>
      setReactFlowInstance(_reactFlowInstance);
  
  
  
    const onElementClick = (event, element) => {
        event.preventDefault();
        setSelectedElement(element)
    }


    return (

          <div className="processrefinement">

          </div>

    );


  };

  
  export default ProcessRefinement;